import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubTask = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_8803",
	"data-name": "Group 8803",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 15,
	height: 16,
	viewBox: "0 0 15 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_14505",
				"data-name": "Rectangle 14505",
				width: 15,
				height: 16,
				fill: "#dad9ef",
				stroke: "#618cf5",
				strokeWidth: 1
			})
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_8802",
			"data-name": "Group 8802",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_8801",
				"data-name": "Group 8801",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_13642",
					"data-name": "Path 13642",
					d: "M10.314,12.314V16.24H.5V2.5H14.24v9.814Z",
					transform: "translate(-0.173 -0.864)",
					fill: "#dad9ef",
					stroke: "#618cf5",
					strokeLinejoin: "round",
					strokeWidth: 1
				}), /* @__PURE__ */ _jsx("line", {
					id: "Line_665",
					"data-name": "Line 665",
					x1: 3.926,
					y2: 3.926,
					transform: "translate(10.141 11.45)",
					fill: "none",
					stroke: "#618cf5",
					strokeLinejoin: "round",
					strokeWidth: 1
				})]
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13643",
			"data-name": "Path 13643",
			d: "M6.944,7.5,4.981,9.463,4,8.481",
			transform: "translate(-1.383 -2.593)",
			fill: "#dad9ef",
			stroke: "#618cf5",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13644",
			"data-name": "Path 13644",
			d: "M6.944,13,4.981,14.963,4,13.981",
			transform: "translate(-1.383 -4.495)",
			fill: "#dad9ef",
			stroke: "#618cf5",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("line", {
			id: "Line_670",
			"data-name": "Line 670",
			x2: 4.253,
			transform: "translate(6.87 6.216)",
			fill: "none",
			stroke: "#618cf5",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("line", {
			id: "Line_671",
			"data-name": "Line 671",
			x2: 4.253,
			transform: "translate(6.87 9.487)",
			fill: "none",
			stroke: "#618cf5",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		})
	]
});
export default SvgSubTask;
